import React, { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import FacilityDetail from './FacilityDetail';
import RecommendPlanList from './RecommendPlanList';
import Pager from '../molecules/Pager';
import {
  fetchHotels,
} from '../../modules/hotel';
import NoResults from '../molecules/NoResults';
import { scrollToRef } from '../../utils/scroll';
import { BASENAME, SHOWING_HOTEL_LIMIT } from '../../constants';
import { makeAdditionalParamsPlanList } from '../../utils/queryParams';
import { getSelectedPlanOptionsState } from '../../utils/localStorage';
import { sessionKey } from '../../modules/app';

const selector = (state) => ({
  flight: state.flight,
  hotel: state.hotel,
});

const SearchResultFacility = (props) => {
  const {
    handlePlanSelect,
    handleClickPlanDetailLink,
    hidePlanListLink,
    handleClickPlanListLink,
    planStartDate,
    hotelIdsWithExpandPlanList,
    fetchHotelsInput,
    editingAccommodation = false,
  } = props;

  const { flight, hotel } = useSelector(selector);
  const {
    outboundFlights,
    inboundFlights,
    fetchingOutbound,
    fetchingInbound,
  } = flight;
  const {
    paginatorInfo,
    hotels,
    fetching: fetchingHotel,
    searchedHotelsInput,
  } = hotel;
  // localStorageからplanOptionsを取得
  const planOptionsFromStorage = getSelectedPlanOptionsState(sessionKey);
  const planOptions = Array.isArray(planOptionsFromStorage) ? planOptionsFromStorage : [];
  
  const dispatch = useDispatch();

  const resultRef = useRef(null);

  const handlePageChange = useCallback((page) => {
    dispatch(
      fetchHotels(
        fetchHotelsInput,
        SHOWING_HOTEL_LIMIT,
        page
      )
    );

    scrollToRef(resultRef, true);
  }, [fetchHotelsInput]);

  const validOutbound = !!(outboundFlights && outboundFlights.length);
  const validInbound = !!(inboundFlights && inboundFlights.length);
  const showHotels = !!(validOutbound && validInbound && hotels && hotels.length);

  if (!searchedHotelsInput || fetchingOutbound || fetchingInbound || fetchingHotel) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="searchResultFacility" ref={resultRef}>
        {showHotels ? hotels.map((hotel) => {
          const hotelId = hotel.id;
          const paramsPlanList = makeAdditionalParamsPlanList(hotelId);

          const withExpandPlanList = hotelIdsWithExpandPlanList && hotelIdsWithExpandPlanList.includes(hotelId);

          return (
            <React.Fragment key={hotelId}>
              <FacilityDetail
                hotel={hotel}
              />
              <RecommendPlanList
                handlePlanSelect={handlePlanSelect}
                handleClickPlanDetailLink={handleClickPlanDetailLink}
                plans={hotel.plans.map((p) => { return { ...p, hotel }; })}
                handleClickPlanListLink={handleClickPlanListLink}
                hidePlanListLink={hidePlanListLink}
                planStartDate={planStartDate}
                maxPlanDisplayNumber={withExpandPlanList ? 15 : undefined}
                editingAccommodation={editingAccommodation}
                paramsPlanList={paramsPlanList}
                selectedPlanOptions={planOptions}
              />
            </React.Fragment>
          );
        }) : (
          <div style={{ marginTop: 70 }}>
            <NoResults
              title="ご迷惑をおかけしております"
              desc="該当の施設が無いか、アクセスが集中して繋がりにくくなっております。<br/>条件を変えていただくか、しばらくして再検索していただけますようお願い申し上げます。"
            />
          </div>
        )}
      </div>
      {showHotels && paginatorInfo && (
        <div className="PagerWrapper">
          <Pager
            currentPage={paginatorInfo.currentPage}
            lastPage={paginatorInfo.lastPage}
            handlePageChange={handlePageChange}
          />
        </div>
      )}
    </React.Fragment>
  );
};

SearchResultFacility.propTypes = {
  handlePlanSelect: PropTypes.func,
  handleClickPlanDetailLink: PropTypes.func,
  hidePlanListLink: PropTypes.bool,
  planStartDate: PropTypes.string,
  handleClickPlanListLink: PropTypes.func,
  hotelIdsWithExpandPlanList: PropTypes.array,
  fetchHotelsInput: PropTypes.object.isRequired,
  editingAccommodation: PropTypes.bool.isRequired,
};

export default SearchResultFacility;
